import type { PaymentStatus } from '@runik/shared';
import { Badge } from '../ui/badge';

const LABEL: Record<PaymentStatus, string> = {
  pending: 'Beklemede',
  paid: 'Ödendi',
  overdue: 'Vadesi Geçmiş',
  cancelled: 'İptal',
};

const VARIANT: Record<PaymentStatus, 'default' | 'success' | 'warning' | 'destructive' | 'secondary'> = {
  pending: 'warning',
  paid: 'success',
  overdue: 'destructive',
  cancelled: 'secondary',
};

export function PaymentStatusBadge({ status }: { status: PaymentStatus }) {
  return <Badge variant={VARIANT[status]}>{LABEL[status]}</Badge>;
}
